import { Auditable } from './base/auditable';
import { OriginalEntityValue } from './base/original-entity-value';
export class MedicalAppointmentCancel {
  public MedicalAppointmentIds: number[];
  public MedicalAppointmentCancelReasonId: number;
  public IsReschedule: boolean;
  public Observations: string;
}

export class MedicalAppointmentCancelReason {
  public Id: number;
  public Name: string;
}

export class MedicalAppointmentConfirmation implements Auditable {
  public Date: string;
  public CreateDate: Date;
  public CreateUser: number;
  public UpdateDate?: Date;
  public UpdateUser?: number;
  public OriginalEntityValue: OriginalEntityValue;
  public Id: number;
  public ConfirmationStatusId: number;
  public ConfirmationObservation: string;
  public MedicalAppointmentId: number;
}
